import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { useOutletContext } from 'react-router-dom';
import { useAuth } from "../../../context/auth-context";
import { formatDate, formatToZMW, handlePrint, rootUrl } from "../../../helpers";
import axios from "axios";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { FaEye, FaMoneyBill, FaPlus, FaPrint, FaReceipt, FaTimes, FaSearch, FaFilter, FaCalendarAlt, FaSpinner } from "react-icons/fa";
import { FaFileLines, FaUsersGear } from "react-icons/fa6";
import AddBillModal from "../bills/addBill";
import CustomerData from "./customerStatement";
import { customStyles } from "../../../styles";
import Receipt from "../../../components/reciept";  
import ReceiptPage from "../../mobile/receipt";


const CustomerPage = (props = {}) => {
  const [showModal, setShowModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [title, setTitle] = useState('');
  const [output, setOutput] = useState('');
  const [showSlidingDiv, setShowSlidingDiv] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [transactions, setTransactions] = useState([]);
    const [filteredCashbooks, setFilteredCashbooks] = useState([]);
      const [isSearching, setIsSearching] = useState(false);
      const [hasSearched, setHasSearched] = useState(false);
      const [filters, setFilters] = useState({
        startDate: '',
        endDate: '',
        bank: '',
        customer: '',
        search: '',
      });
 const [formData, setFormData] = useState({
    name: "",
    nrc: "",
    phoneNumber: "",
    email: "",
    address: "",
    
  });


  // Try to get allData from props first, then fall back to useOutletContext
  const outletContext = useOutletContext();
  const {allData, setAllData} = outletContext || { allData: props.allData, setAllData: props.setAllData };
  const auth = useAuth();

   const componentRef = useRef(null);

  const fetchReceipts = () => {
    axios.get(rootUrl(`/getReceipts/${auth.user.id}`)) 
    .then((response) => {
      const rows = response.data.data || [];
      setTransactions(rows);
      setFilteredCashbooks(rows);
      setHasSearched(false);
    })
    .catch((error) => console.error("Error fetching suppliers:", error));
  };

  useEffect(() => {
    fetchReceipts();
  }, []); 



  function isAnyValueEmpty(obj) {
    return Object.values(obj).some(value => 
        value === null || value === undefined || value === ''
    );
}

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    formData['uid'] = auth.user.id
    try{
       if(isAnyValueEmpty(formData)){
            toast.error("Please ensure to fill in all fields")
            return
          }
          formData['type'] = 3;
      const response = await axios.post(rootUrl("/addCustomer"), formData)
      if(response.data.status === 200){
        toast.success("Submitted successfully")
        setShowModal(false)
        setFormData(
          {
            name: "",
            nrc: "",
            phoneNumber: "",
            email: "",
            address: "",
            
          }
        )

        axios.get(rootUrl(`/getCustomers/${auth.user.id}`)) 
      .then((response) => setAllData((prevData) => ({
        ...prevData, 
        suppliers: response.data.data,
      })))
      .catch((error) => console.error("Error fetching suppliers:", error));

      
      }else{
        toast.info(response.data.msg)
      }

    }catch(e){
      toast.error(e?.message)
    }

  };

  const openSlidingDiv = () => {
    setShowSlidingDiv(true);
  };

  const closeSlidingDiv = () => {
    setShowSlidingDiv(false);
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };


  const display = (obj) => {
    openSlidingDiv();
    if (obj.type === 'income') {
      if(props.allData){
        setTitle("Receipt");
        setOutput(<ReceiptPage receipt={transactions.filter(a=>a.voucher == obj.voucher)} allData={allData} council={allData.council[0].name} />);
      }else{
      setTitle("Receipt");
      setOutput(<Receipt data={transactions.filter(a=>a.voucher == obj.voucher)} ref={componentRef} />);
      }
    } 
  };

 const columns = [
    {
      name: 'Sn',
      selector: (row, index) => index + 1,
      sortable: true,
      width: '50px',
    },
    {
      name: 'Date',
      selector: (row) => formatDate(row.date.substring(0, 10)),
      sortable: true,
    },
    {
      name: 'Chart of Account',
      selector: (row) =>
        allData?.budget?.find((a) => a.id == row.coa_id)?.coa || '',
      sortable: true,
    },
    {
      name: 'Bank',
      selector: (row) =>
        allData?.bank?.find((a) => a.id === row.bank)?.name || '',
      sortable: true,
    },
    {
      name: 'Description',
      selector: (row) => row.description || '',
      sortable: true,
    },
    {
      name: 'Voucher #',
      selector: (row) => row.voucher || '',
      sortable: true,
    },{
      name: 'Cheque #',
      selector: (row) => row.cheque || '',
      sortable: true,
    },
    {
      name: 'Payee',
      selector: (row) => allData?.suppliers?.find((a) => a.id == row.paye)?.name || ''
        
      ,
      sortable: true,
    },
    {
      name: 'Project',
      selector: (row) => allData?.projects?.find((a) => a.id == row.proj_id)?.name || ''
      ,
      sortable: true,
    },
    {
      name: 'Debit',
      selector: (row) => (row.type === 'income' ? formatToZMW(row.amount) : 0),
      sortable: true,
    },
    {
      name: 'Credit',
      selector: (row) => (row.type === 'expense' ? formatToZMW(row.amount) : 0),
      sortable: true,
    },
    {
      name: 'Balance',
      selector: (row) => formatToZMW(row.balance || 0),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <button
          className="p-2 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-lg transition-colors"
          onClick={() => display(row)}
          title="View Receipt"
        >
          <FaEye className="text-sm" />
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const addPay = (id, type, name) =>{
    if(type === 1){

        setTitle("Add Receipt")
        setOutput(<AddBillModal data={allData} onSubmit={onSubmit} type={1} />)
    }else{

        setTitle("Customer Statement")
        setOutput(<CustomerData id={id} name={name} />)
    }
    openSlidingDiv()

  }

  const onSubmit = async (payload)=>{

        payload['uid'] = auth.user.id
        try{
            const response = await axios.post(rootUrl('/addBillAndPayment'), payload)
            if(response.data.status === 200){
                toast.success("Submitted successfully")
                setShowSlidingDiv(false)
                fetchReceipts();
            
            }else{
                toast.error("Something went wrong")
            }
      
        }catch(e){
            toast.error(e?.message)
        }
    
  }

  const handleSearchTransactions = async () => {
    const hasAnyFilter =
      Boolean(filters.startDate) ||
      Boolean(filters.endDate) ||
      Boolean(filters.bank) ||
      Boolean(filters.customer) ||
      Boolean(filters.search?.trim());
    if (!hasAnyFilter) {
      toast.info("Enter at least one filter, then click Search.");
      return;
    }

    setIsSearching(true);
    try {
      const response = await axios.post(rootUrl(`/searchReceipts`), {
        uid: auth.user.id,
        startDate: filters.startDate || "",
        endDate: filters.endDate || "",
        bank: filters.bank || "",
        customer: filters.customer || "",
        search: (filters.search || "").trim(),
      });
      const rows = response.data?.data || [];
      setTransactions(rows);
      setFilteredCashbooks(rows);
      setHasSearched(true);
    } catch (error) {
      console.error("Error searching receipts:", error);
      toast.error("Failed to search receipts");
    } finally {
      setIsSearching(false);
    }
  };

  const handleClearFilters = () => {
    setFilters({
      startDate: '',
      endDate: '',
      bank: '',
      customer: '',
      search: '',
    });
    fetchReceipts();
  };
  
  const finalBalance = filteredCashbooks.reduce((total, row) => {
    const amount = parseFloat(row.amount) || 0; 
    return row.type === 'income' ? total + amount : total - amount;
  }, 0);
  const calculateBalance = () => {
    let balance = 0;
    return filteredCashbooks.map((row) => {
      balance += row.type === 'income' ? parseFloat(row.amount) : - parseFloat(row.amount);
      return { ...row, balance };
    });
  };

  const customerOptions = (allData?.suppliers || []).map((supplier) => ({
    value: supplier.id,
    label: supplier.name,
  }));


  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-white/20 rounded-xl p-3">
              <FaReceipt className="text-2xl" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold">Receipts</h1>
              <p className="text-blue-100 text-sm mt-1">View and manage all customer receipt transactions</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button 
              className="flex items-center gap-2 px-4 py-2.5 bg-white/20 hover:bg-white/30 text-white rounded-lg transition-colors text-sm font-medium"
              onClick={()=>addPay(1, 1)}
            >
              <FaPlus />
              <span>Add Receipt</span>
            </button>
            <button
              onClick={toggleModal}
              className="flex items-center gap-2 px-4 py-2.5 bg-white text-blue-950 rounded-lg hover:bg-blue-50 transition-colors font-medium shadow-sm"
            >
              <FaPlus />
              <span>Add Customer</span>
            </button>
          </div>
        </div>
      </div>

      <div id="allCust">
        {/* Filters */}
        <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <div className="flex items-center gap-2">
                  <FaCalendarAlt className="text-gray-500 text-sm" />
                  <span>Start Date</span>
                </div>
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 px-4 py-2.5 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                value={filters.startDate}
                onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <div className="flex items-center gap-2">
                  <FaCalendarAlt className="text-gray-500 text-sm" />
                  <span>End Date</span>
                </div>
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 px-4 py-2.5 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                value={filters.endDate}
                onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <div className="flex items-center gap-2">
                  <FaFilter className="text-gray-500 text-sm" />
                  <span>CashBook</span>
                </div>
              </label>
              <select
                className="w-full border border-gray-300 px-4 py-2.5 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                value={filters.bank}
                onChange={(e) => setFilters({ ...filters, bank: e.target.value })}
              >
                <option value="">All CashBooks</option>
                {allData?.bank?.map((bank) => (
                  <option key={bank.id} value={bank.id}>{bank.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Customer</label>
              <Select
                options={customerOptions}
                placeholder="Select customer"
                isClearable
                value={customerOptions.find(option => option.value === filters.customer)}
                onChange={(selectedOption) =>
                  setFilters({ ...filters, customer: selectedOption ? selectedOption.value : "" })
                }
                className="text-sm"
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '42px',
                    borderColor: '#D1D5DB',
                    borderRadius: '0.5rem',
                    boxShadow: 'none',
                    '&:hover': {
                      borderColor: '#D1D5DB'
                    }
                  })
                }}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <div className="flex items-center gap-2">
                  <FaSearch className="text-gray-500 text-sm" />
                  <span>Search</span>
                </div>
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <FaSearch className="h-4 w-4 text-gray-400" />
                </div>
                <input
                  type="text"
                  placeholder="Search by description, voucher or cheque..."
                  className="w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                  value={filters.search}
                  onChange={(e) => setFilters({ ...filters, search: e.target.value })}
                />
                {filters.search && (
                  <button
                    onClick={() => setFilters({ ...filters, search: '' })}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    <FaTimes className="h-4 w-4" />
                  </button>
                )}
              </div>
            </div>
            <div className="flex items-end">
              <div className="bg-white px-4 py-2.5 rounded-lg border border-gray-300 text-sm text-gray-700 font-medium w-full">
                Showing: {filteredCashbooks.length} record{filteredCashbooks.length === 1 ? "" : "s"}
              </div>
            </div>
            <div className="flex items-end gap-2">
              <button
                type="button"
                onClick={handleSearchTransactions}
                disabled={isSearching}
                className="inline-flex items-center rounded-lg bg-blue-950 px-4 py-2 text-sm font-medium text-white hover:bg-blue-900 disabled:opacity-60"
              >
                {isSearching ? "Searching..." : "Search"}
              </button>
              <button
                type="button"
                onClick={handleClearFilters}
                className="inline-flex items-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                Clear
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        <p className="text-xs text-gray-500 mt-3 mb-2">
          {hasSearched
            ? "Filtered receipt transactions."
            : "Showing your latest 10 receipt transactions. Use filters + Search to fetch more."}
        </p>
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
          <DataTable
            title=""
            columns={columns}
            data={calculateBalance()}
            pagination
            highlightOnHover
            striped
            responsive
            customStyles={customStyles}
          />
        </div>
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 text-right">
          <span className="text-sm font-medium text-gray-700">Balance: </span>
          <span className="text-lg font-bold text-blue-950">{formatToZMW(finalBalance)}</span>
        </div>
      </div>

      {/* Sliding Div */}
      {showSlidingDiv && (
        <div className="fixed inset-0 z-40 flex justify-end">
          <div
            className="flex-1 bg-black/40"
            onClick={closeSlidingDiv}
          />
          <div
            id="slidingDiv"
            className="bg-white fixed top-0 right-0 h-full w-full sm:w-4/5 lg:w-2/3 xl:w-1/2 overflow-hidden shadow-2xl flex flex-col"
          >
            <div className="bg-gradient-to-r from-blue-950 to-blue-800 px-6 py-4 text-white">
              <div className="flex items-center justify-between">
                <h3 className="m-0 font-bold text-lg md:text-xl">{title}</h3>
                <button 
                  onClick={closeSlidingDiv}
                  className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-white/20 text-white hover:bg-white/30 transition-colors"
                >
                  <FaTimes size={14}/>
                </button>
              </div>
            </div>
            <div className="flex gap-3 p-4 border-b border-gray-200 bg-gray-50">
              <button
                onClick={() => handlePrint(componentRef)}
                className="inline-flex items-center gap-2 bg-blue-950 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-900 transition-colors"
              >
                <FaPrint />
                <span>Print</span>
              </button>
            </div>
            <div className="h-[90vh] overflow-auto p-4 md:p-6 bg-gray-50" id="form">{output}</div>
          </div>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <form
            onSubmit={handleSubmit}
            className="bg-white rounded-2xl p-4 md:p-5 w-full max-w-xl shadow-xl overflow-y-auto"
          >
            <div className="flex justify-between items-center mb-3 border-b pb-3">
              <h2 className="text-lg md:text-xl font-semibold text-gray-800">Add New Customer</h2>
              <button
                type="button"
                onClick={toggleModal}
                className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-200"
              >
                <FaTimes size={14}/>
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Name <span className="text-red-500">*</span>
                </label>
                <input
                  name="name"
                  placeholder='Enter name'
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  NRC <span className="text-red-500">*</span>
                </label>
                <input
                  name="nrc"
                  placeholder='Enter NRC'
                  value={formData.nrc}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  name="phoneNumber"
                  placeholder="Enter phone number"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  name="email"
                  placeholder="Enter email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Address <span className="text-red-500">*</span>
                </label>
                <input
                  name="address"
                  placeholder="Enter address"
                  value={formData.address}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
              </div>
            </div>

            <div className="mt-6 pt-4 border-t border-gray-200 flex justify-end gap-3">
              <button
                type="button"
                onClick={toggleModal}
                className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-2.5 bg-gradient-to-r from-blue-950 to-blue-800 text-white rounded-lg hover:shadow-lg transition-all font-medium flex items-center gap-2"
              >
                <FaPlus />
                <span>Add Customer</span>
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default CustomerPage;
